// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pU-z","hovered":"qU-z","hoverImage":"rU-z","mainImage":"sU-z","imageNoBackground":"tU-z","fullSizeImage":"uU-z"};